import { FilterContexType } from "../../layout/ViewHeader";

export const isFilterVisibleInContext = (visibility?: FilterContexType, context?: FilterContexType): boolean => {
	if (!visibility?.length) return true;
	if (!context?.length) return true;

	return visibility.some((v) => context.includes(v));
};
